import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar";
import SignInModal from "../../components/SignInModal";
import BLOG_ARTICLES from "./articles";

const BRAND_COLOR = "#1a3f6b";
const BRAND_ACCENT_COLOR = "#10b981";


const articles = Object.values(BLOG_ARTICLES).sort((a, b) => {
  // Sort newest first by parsing the date strings
  return new Date(b.date) - new Date(a.date);
});

export default function BlogList() {
  const [showSignIn, setShowSignIn] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isTablet, setIsTablet] = useState(window.innerWidth >= 768 && window.innerWidth < 1024);

  useEffect(() => {
    const onResize = () => {
      setIsMobile(window.innerWidth < 768);
      setIsTablet(window.innerWidth >= 768 && window.innerWidth < 1024);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const gridColumns = isMobile ? "1fr" : isTablet ? "1fr 1fr" : "1fr 1fr 1fr";

  return (
    <div style={{ fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif", background: "#f9fafb", minHeight: "100vh" }}>
      <Navbar onSignIn={() => setShowSignIn(true)} />

      {/* Hero */}
      <header
        style={{
          background: "linear-gradient(135deg, #0f172a 0%, #1e3a5f 60%, #134e4a 100%)",
          padding: isMobile ? "5rem 1rem 3rem" : "7rem 2rem 4rem",
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* Decorative grid */}
        <div style={{ position: "absolute", inset: 0, backgroundImage: "linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)", backgroundSize: "40px 40px", pointerEvents: "none" }} />
        {/* Floating glow orbs */}
        <div style={{ position: "absolute", top: "-20%", left: "-10%", width: "400px", height: "400px", borderRadius: "50%", background: "radial-gradient(circle, rgba(16,185,129,0.15) 0%, transparent 70%)", pointerEvents: "none", animation: "blogHeroPulse 6s ease-in-out infinite" }} />
        <div style={{ position: "absolute", bottom: "-30%", right: "-5%", width: "500px", height: "500px", borderRadius: "50%", background: "radial-gradient(circle, rgba(59,130,246,0.12) 0%, transparent 70%)", pointerEvents: "none", animation: "blogHeroPulse 8s ease-in-out 2s infinite" }} />
        <style>{`@keyframes blogHeroPulse { 0%, 100% { transform: scale(1); opacity: 0.7; } 50% { transform: scale(1.15); opacity: 1; } }`}</style>
        <div style={{ maxWidth: "780px", margin: "0 auto", position: "relative", zIndex: 1 }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: "0.5rem", padding: "0.35rem 1rem", background: "rgba(16,185,129,0.15)", border: "1px solid rgba(16,185,129,0.3)", borderRadius: "999px", fontSize: "0.8rem", fontWeight: 600, color: "#10b981", marginBottom: "1.25rem", letterSpacing: "0.04em", textTransform: "uppercase" }}>
            <span style={{ width: "6px", height: "6px", borderRadius: "50%", background: "#10b981", display: "inline-block" }} />
            Insights & Updates
          </div>
          <h1 style={{ fontSize: isMobile ? "2.25rem" : "3.25rem", fontWeight: 800, color: "#fff", lineHeight: 1.1, marginBottom: "1rem", letterSpacing: "-0.03em" }}>
            The Vendorleads Blog
          </h1>
          <p style={{ fontSize: isMobile ? "1.05rem" : "1.2rem", color: "rgba(255,255,255,0.6)", lineHeight: 1.6, maxWidth: "540px", margin: "0 auto" }}>
            Product updates, tips, and insights for real estate agents.
          </p>
        </div>
      </header>

      {/* Card Grid */}
      <main style={{ maxWidth: "1100px", margin: "0 auto", padding: isMobile ? "2rem 1rem" : "3rem 2rem 4rem" }}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: gridColumns,
            gap: isMobile ? "1.25rem" : "1.5rem",
          }}
        >
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/blog/${article.slug}`}
              style={{ textDecoration: "none", color: "inherit", display: "flex" }}
            >
              <div
                style={{
                  background: "#fff",
                  borderRadius: "14px",
                  border: "1px solid #e5e7eb",
                  overflow: "hidden",
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                  transition: "box-shadow 0.2s ease, transform 0.2s ease",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
                  e.currentTarget.style.transform = "translateY(-3px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = "none";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                {/* Card hero band */}
                <div
                  style={{
                    background: "linear-gradient(135deg, #0f172a 0%, #1e3a5f 60%, #134e4a 100%)",
                    padding: article.cardImage ? "0" : "2rem 1.5rem 1.5rem",
                    textAlign: "center",
                    position: "relative",
                    overflow: "hidden",
                  }}
                >
                  {article.cardImage ? (
                    <>
                      <img
                        src={article.cardImage}
                        alt={article.title}
                        style={{
                          display: "block",
                          width: "100%",
                          height: "180px",
                          objectFit: "cover",
                          objectPosition: "top",
                        }}
                      />
                      {article.isProductUpdate && (
                        <span
                          style={{
                            position: "absolute",
                            top: "0.6rem",
                            right: "0.6rem",
                            padding: "0.15rem 0.6rem",
                            fontSize: "0.65rem",
                            fontWeight: 700,
                            color: "#fff",
                            background: "rgba(0,0,0,0.5)",
                            backdropFilter: "blur(4px)",
                            borderRadius: "999px",
                            textTransform: "uppercase",
                            letterSpacing: "0.05em",
                            border: "1px solid rgba(255,255,255,0.2)",
                          }}
                        >
                          Product Update
                        </span>
                      )}
                    </>
                  ) : (
                    <>
                      <div style={{ fontSize: "2.5rem", marginBottom: "0.5rem" }}>{article.heroEmoji}</div>
                      {article.isProductUpdate && (
                        <span
                          style={{
                            display: "inline-block",
                            padding: "0.15rem 0.6rem",
                            fontSize: "0.65rem",
                            fontWeight: 700,
                            color: "#fff",
                            background: "rgba(255,255,255,0.15)",
                            borderRadius: "999px",
                            textTransform: "uppercase",
                            letterSpacing: "0.05em",
                            marginBottom: "0.5rem",
                            border: "1px solid rgba(255,255,255,0.2)",
                          }}
                        >
                          Product Update
                        </span>
                      )}
                    </>
                  )}
                </div>

                {/* Card body */}
                <div style={{ padding: "1.25rem 1.5rem 1rem", flex: 1, display: "flex", flexDirection: "column" }}>
                  <h2
                    style={{
                      fontSize: "1.1rem",
                      fontWeight: 700,
                      color: BRAND_COLOR,
                      lineHeight: 1.35,
                      marginBottom: "0.6rem",
                      margin: "0 0 0.6rem 0",
                    }}
                  >
                    {article.title}
                  </h2>
                  <p
                    style={{
                      fontSize: "0.88rem",
                      color: "#6b7280",
                      lineHeight: 1.6,
                      flex: 1,
                      margin: "0 0 1rem 0",
                      display: "-webkit-box",
                      WebkitLineClamp: 3,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                    }}
                  >
                    {article.previewParagraph}
                  </p>

                  {/* Tags */}
                  {article.tags && article.tags.length > 0 && (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "0.35rem", marginBottom: "1rem" }}>
                      {article.tags.map((tag) => (
                        <span
                          key={tag}
                          style={{
                            padding: "0.15rem 0.55rem",
                            fontSize: "0.68rem",
                            fontWeight: 600,
                            color: BRAND_COLOR,
                            background: "#eef2f7",
                            borderRadius: "999px",
                          }}
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  )}

                  {/* Meta */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "0.5rem",
                      fontSize: "0.78rem",
                      color: "#9ca3af",
                      borderTop: "1px solid #f3f4f6",
                      paddingTop: "0.85rem",
                      marginTop: "auto",
                    }}
                  >
                    <span>{article.date}</span>
                    <span>·</span>
                    <span>{article.readTime}</span>
                    <span style={{ marginLeft: "auto", color: BRAND_ACCENT_COLOR, fontWeight: 600, fontSize: "0.8rem" }}>
                      Read →
                    </span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </main>

      {showSignIn && <SignInModal show={showSignIn} onHide={() => setShowSignIn(false)} />}
    </div>
  );
}
